import api from './api';
import { Conversation, Message } from '@/types/chat-types';

interface PaginatedConversationsResponse {
  data: Conversation[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export default {
  // Dobavljanje svih konverzacija korisnika sa paginacijom
  async getConversations(
    page: number = 1,
    limit: number = 4
  ): Promise<PaginatedConversationsResponse> {
    const response = await api.get(
      `/api/messages/conversations?page=${page}&limit=${limit}`
    );
    return {
      data: response.data.data,
      meta: response.data.meta,
    };
  },

  // Stara metoda bez paginacije (za backward compatibility)
  async getAllConversations(): Promise<Conversation[]> {
    const response = await api.get('/api/messages/conversations/all');
    return response.data.data;
  },

  // Dobavljanje poruka za određenu konverzaciju
  async getConversationMessages(
    otherUserId: string,
    productId: string
  ): Promise<Message[]> {
    const response = await api.get(
      `/api/messages/conversations/${otherUserId}/${productId}`
    );
    return response.data.data;
  },

  // Dobavljanje informacija o proizvodu preko sluga
  async getProductBySlug(slug: string): Promise<any> {
    const response = await api.get(`/api/products/${slug}`);
    return response.data;
  },

  // Slanje nove poruke
  async sendMessage(
    receiverId: string,
    productId: string,
    content: string
  ): Promise<Message> {
    const response = await api.post('/api/messages', {
      receiverId,
      productId,
      content,
    });
    return response.data.data;
  },

  // Brisanje cele konverzacije
  async deleteConversation(
    otherUserId: string,
    productId: string
  ): Promise<void> {
    await api.delete(`/api/messages/conversations/${otherUserId}/${productId}`);
  },
};
